import "./OpenMenu.css";
import close from "../../../../img/close.svg";
import ScrollToButton from "../../../scrollToButton";

const OpenMenu = (props) => {
  return (
    <>
      <div className="openMenu">
        <img src={close} tabIndex={0} onKeyDown={props.closeMenuTab} onClick={props.close} alt="Close menu icon" />
        <ul>
          <ScrollToButton className='menu_btn' close={props.close} toId="speakers">Speakers</ScrollToButton>
          <ScrollToButton className='menu_btn' close={props.close} toId="agenda">Agenda</ScrollToButton>
          <ScrollToButton className='menu_btn' close={props.close} toId="tickets">Tickets</ScrollToButton>
          {/* <ScrollToButton className='menu_btn' close={props.close} toId="sponsors">Sponsors</ScrollToButton> */}
          {/* <ScrollToButton className='menu_btn' close={props.close} toId="partners">Partners</ScrollToButton> */}
          <ScrollToButton className='menu_btn' close={props.close} toId="pc">Committee</ScrollToButton>
          <ScrollToButton className='menu_btn' close={props.close} toId="sponsorship">Become a sponsor</ScrollToButton>
          <ScrollToButton className='menu_btn' close={props.close} toId="team">Team</ScrollToButton>
        </ul>
      </div>
    </>
  );
};
export default OpenMenu;
